import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-gradient-to-b from-[#08111F] to-[#0F1F38] text-white overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[36rem] h-[36rem] rounded-full bg-[#C9A84C]/10 blur-3xl pointer-events-none"></div>
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-white/5 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Página não encontrada</h1>
        <p className="mt-2 text-base text-white/84 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-white/90">O conteúdo que você procura não foi encontrado no Aero Passport.</p>
      </div>
    </div>
  );
}
